/* Contact & Calendly – interactieve placeholder (alleen zichtbaar zolang er geen Calendly-code is). */
if (!customElements.get('contact-calendly-preview')) {
  class ContactCalendlyPreview extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';

      this.locale = this.dataset.locale || document.documentElement.lang || 'en';
      this.hint = this.dataset.hint || '';
      this.times = (this.dataset.times || '').split(',').map((t) => t.trim()).filter(Boolean);

      const now = new Date();
      this.today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      this.view = new Date(now.getFullYear(), now.getMonth(), 1);
      this.selectedDate = null;
      this.selectedTime = null;

      this.monthEl = this.querySelector('[data-month]');
      this.daysEl = this.querySelector('[data-days]');
      this.weekdaysEl = this.querySelector('[data-weekdays]');
      this.timesEl = this.querySelector('[data-times-list]');
      this.selectionEl = this.querySelector('[data-selection]');
      this.continueBtn = this.querySelector('[data-continue]');
      this.prevBtn = this.querySelector('[data-prev]');

      this.prevBtn.addEventListener('click', () => this.shift(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.shift(1));

      this.renderWeekdays();
      this.renderTimes();
      this.renderMonth();
    }

    shift(step) {
      this.view = new Date(this.view.getFullYear(), this.view.getMonth() + step, 1);
      this.renderMonth();
    }

    renderWeekdays() {
      const fmt = new Intl.DateTimeFormat(this.locale, { weekday: 'narrow' });
      // 5 januari 2026 is een maandag
      this.weekdaysEl.innerHTML = '';
      for (let i = 0; i < 7; i++) {
        const span = document.createElement('span');
        span.textContent = fmt.format(new Date(2026, 0, 5 + i));
        this.weekdaysEl.appendChild(span);
      }
    }

    renderMonth() {
      const y = this.view.getFullYear();
      const m = this.view.getMonth();
      this.monthEl.textContent = new Intl.DateTimeFormat(this.locale, { month: 'long', year: 'numeric' }).format(this.view);

      const isCurrentMonth = y === this.today.getFullYear() && m === this.today.getMonth();
      this.prevBtn.disabled = isCurrentMonth;

      this.daysEl.innerHTML = '';
      const offset = (new Date(y, m, 1).getDay() + 6) % 7; // maandag = 0
      for (let i = 0; i < offset; i++) this.daysEl.appendChild(document.createElement('span'));

      const total = new Date(y, m + 1, 0).getDate();
      for (let d = 1; d <= total; d++) {
        const date = new Date(y, m, d);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'contact-calendly__day';
        btn.textContent = d;
        btn.disabled = date < this.today;
        btn.setAttribute('aria-pressed', this.sameDay(date, this.selectedDate) ? 'true' : 'false');
        btn.addEventListener('click', () => {
          this.selectedDate = date;
          this.renderMonth();
          this.updateSelection();
        });
        this.daysEl.appendChild(btn);
      }
    }

    renderTimes() {
      this.timesEl.innerHTML = '';
      this.times.forEach((time) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'contact-calendly__time';
        btn.textContent = time;
        btn.setAttribute('aria-pressed', 'false');
        btn.addEventListener('click', () => {
          this.selectedTime = time;
          this.timesEl.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
          this.updateSelection();
        });
        this.timesEl.appendChild(btn);
      });
    }

    updateSelection() {
      if (this.selectedDate && this.selectedTime) {
        const label = new Intl.DateTimeFormat(this.locale, { weekday: 'short', day: 'numeric', month: 'short' }).format(this.selectedDate);
        this.selectionEl.textContent = `${label} · ${this.selectedTime}`;
        this.continueBtn.disabled = false;
      } else {
        this.selectionEl.textContent = this.hint;
        this.continueBtn.disabled = true;
      }
    }

    sameDay(a, b) {
      return !!b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }
  }
  customElements.define('contact-calendly-preview', ContactCalendlyPreview);
}

/* Contact & Calendly – automatische slideshow (alleen bij meer dan één afbeelding). */
if (!customElements.get('contact-calendly-slides')) {
  class ContactCalendlySlides extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.contact-calendly__image'));
      if (!this.hasAttribute('data-autoplay') || this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;

      // volgende afbeelding vast laden, zodat de overgang niet hapert
      this.slides.forEach((img) => { img.loading = 'eager'; });

      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }
  }
  customElements.define('contact-calendly-slides', ContactCalendlySlides);
}
